import React from "react";
import Budget from '../components/Budget'

const BudgetView = (props) => {

    const { space_id } = props.match ? props.match.params : { space_id: null };


    return (
        <div>
            <Budget space_id={space_id} />
        </div>
    )
}


export default BudgetView;